import React, { useState, useEffect } from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './style.css';
import NotificationRequestService from 'services/notification-request';
import { LeakAddTwoTone, Notifications } from '@material-ui/icons';
import NotificationBell from 'components/AlertNotification/NotificationBell';
import { useLocation } from 'react-router-dom';
import { useUser } from 'models';
import { getObjectDate, getTime } from './utils';
import NewNotification from 'services/new_notification-request';
import { useHistory } from 'react-router-dom'

const AlertNotification = ({
  setCountNotification,
  style
}) => {
  const history = useHistory();
  const user = useUser()
  const userId = user.id;
  const location = useLocation();

  const [notificationsOld, setNotificationsOld] = useState([]);
  const [notificationsNew, setNotificationsNew] = useState([]);
  const [hasNotification, setHasNotification] = useState(false);

  const [offset, setOffset] = useState(null);
  const [hasMore, setHasMore] = useState(false);

  const [isLoadingMore, setLoadingMore] = useState(false);

  const [countNew, setCountNew] = useState(0);

  const [ids, setIds] = useState([]);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    async function load(pathname){
      if(pathname == window.location.pathname){
        let element = document.getElementsByClassName('notificacao')[0];
        if(element && !element.classList.contains('show')) {
          if(await loadNotification(userId));
          setTimeout(function() {
            load(location.pathname);
          },60000)
        } else if(element){
          setTimeout(function() {
            load(location.pathname);
          },10000)
        }
      }
    }
    load(location.pathname);
  }, []);

  const loadNotification = async (userId, offset) => {
    const res = await NewNotification.fetchByUser(userId, {
      params:{
        offset:offset
      }
    })
    
    let data = res.data

    // let response = await NotificationRequestService.notification({params:{
    //   user_id:userId,
    //   offset:offset
    // }});
    // let data = response.data;
    if(data.data.message == 'ok'){
      data = data.data;
      setOffset(data.offset);
      setHasMore(data.has_more);
      data = data.data;
      setIds(data.filter(a=>a.was_viewed===0).map(a=>a.id));
      setCountNew(data.filter(a=>a.was_viewed===0).map(a=>a.id).length);
      if(setCountNotification)setCountNotification(data.filter(a=>a.was_viewed===0).map(a=>a.id).length);
      setHasNotification(data.filter(a=>a.was_viewed===0).map(a=>a.id).length>0);
      let listnew = data.filter(a=>{
        let dif = new Date().getTime() - getObjectDate(a.notification.created_at).getTime();
        return (dif/(1000*60*60*24)<=1) && getObjectDate(a.notification.created_at).getDate() == new Date().getDate();
      });
      let listold = data.filter(a=>{
        let dif = new Date().getTime() - getObjectDate(a.notification.created_at).getTime();
        return (dif/(1000*60*60*24)>1) || getObjectDate(a.notification.created_at).getDate() != new Date().getDate();
      });

      setNotificationsNew([...listnew]);
      setNotificationsOld([...listold]);
      setLoadingMore(false);
      return true;
    }
  }

  const loadMoreNotification = (userId, offset) => {
    /*NotificationRequestService.notification({params:{
      user_id:userId,
      offset:offset
    }})*/
    
    NewNotification.fetchByUser(userId, {
      params:{
        offset:offset
      }
    }).then(({ data }) => {
      data = data.data;
      setOffset(data.offset);
      setHasMore(data.has_more);
      data = data.data;
      setIds(data.filter(a=>a.was_viewed===0).map(a=>a.id));
      // setCountNew(data.filter(a=>a.was_viewed===0).map(a=>a.id).length);
      if(setCountNotification)setCountNotification(data.filter(a=>a.was_viewed===0).map(a=>a.id).length);
      setHasNotification(data.filter(a=>a.was_viewed===0).map(a=>a.id).length>0);
      let listnew = data.filter(a=>{
        let dif = new Date().getTime() - getObjectDate(a.notification.created_at).getTime();
        return (dif/(1000*60*60*24)<=1) && getObjectDate(a.notification.created_at).getDate() == new Date().getDate();
      });
      let listold = data.filter(a=>{
        let dif = new Date().getTime() - getObjectDate(a.notification.created_at).getTime();
        return (dif/(1000*60*60*24)>1) || getObjectDate(a.notification.created_at).getDate() != new Date().getDate();
      });

      setNotificationsNew([...notificationsNew,...listnew]);
      setNotificationsOld([...notificationsOld,...listold]);
      setLoadingMore(false);
    });
  }

  const setNotificationRead = id => {
    //NotificationRequestService
    
    NewNotification.setRead(id).then(({ data }) => {
      window.location.href = data.data.notification.link;
      //history.push(data.data.notification.link);
    });
    let element = document.getElementsByClassName('notificacao')[0];
    if(element)element.classList.remove('show');
    let modal = element.getElementsByClassName('dropdown-menu')[0];
    if(modal)modal.classList.remove('show');
  };

  const setAllNotificationsRead = () => {
    const getId = () => {
      let a = notificationsNew.length>0?notificationsNew[0]:null;
      let b = notificationsOld.length>0?notificationsOld[0]:null;
      if(a && b){
        if(a.id > b.id)return a.id;
        return b.id;
      }
      else if(a) return a.id;
      else if(b) return b.id;
      return null;
    }
    
    NewNotification.setAllRead(getId()).then(({ data }) => {
      setNotificationsNew([...notificationsNew.map(a=>{
        a.was_read = 1;
        return a;
      })]);
      setNotificationsOld([...notificationsOld.map(a=>{
        a.was_read = 1;
        return a;
      })]);
    });
  };

  const setNotificationsViewed = () => {
    if(ids.length > 0){
      //NotificationRequestService
      
      NewNotification.setViewed({ids:ids}).then(() => {
        setIds([]);
        setHasNotification(false);
        setCountNew(0);
        if(setCountNotification)
          setCountNotification(0);
      });
    }
  };
  
  const createNotification = (notification) => {
    return (
    <div className="body-notification p-2 pb-3 mb-1" key={notification.id}
    style={notification.was_read===0?{background:'#ffe6d1'}:{}} 
    data-time={getTime(notification.notification.created_at)}
    onClick={()=>setNotificationRead(notification.id)}>
      <div className="notification-title" style={notification.was_read===0?{fontWeight: 'bolder'}:{}}>{notification.notification.title}</div>
      <div><a href={'javascript:;'} className="link-notification" onClick={()=>setNotificationRead(notification.id)}>{notification.notification.content}</a></div>
      {notification.was_read!==0?
      <div className="viewed"></div>
      :
      <div className="viewed"><div className="not-read-circle"></div></div>
      }
    </div>
    );
  };

  const createNotificationList = (title,list) => {
    return (<div className="body-notification-group">
    <NavDropdown.Header className="title-notification-group">{title}</NavDropdown.Header>
    {list.map((n,k)=>
      createNotification(n)
    )}
    </div>);
  }

  // icone de notificação
  const getIcon = () => {
    return(
      <>
      <NotificationBell countNew={countNew}/>
      {/* <Badge badgeContent={countNew} color="secondary" max={9}>
        <Notifications style={{color:'#D92530'}}/>
      </Badge> */}
      </>
    );
  }

  return (
    <ul className="list-unstyled float-right mb-0" style={style}>
      <Nav className="mr-auto" id="notificacao">
        <NavDropdown className="nav-text-white notificacao" title={getIcon()} onClick={(e)=>{
          setNotificationsViewed();
          }}>
          <div id="area-notification" onScroll={(e)=>{
            let element = e.target;

            if(element.scrollHeight <= (element.clientHeight + element.scrollTop)+40){
              if(hasMore && !isLoadingMore){
                setLoadingMore(true);
                loadMoreNotification(userId,offset);
              }
            }
          }}>
            <NavDropdown.Header className="title-notification p-3" style={{fontWeight: 'bolder'}}>
            <Notifications style={{color:'white'}} className="mr-2"/>
              Notificações
            </NavDropdown.Header>
            {([...notificationsNew,...notificationsOld]).length>0?(
                <div className="read-all col-12" onClick={setAllNotificationsRead}>
                  <span>Marcar todos como lidos</span>
                </div>
              ):''}
            <div className="list-notifications">
              {notificationsNew.length>0?createNotificationList('Hoje',notificationsNew):''}
              {notificationsOld.length>0?createNotificationList('Mais antigo',notificationsOld):''}
            </div>
            {([...notificationsNew,...notificationsOld]).length==0?(
              <div style={{
                padding: '10px',
                textAlign: 'center'
              }}>Você ainda não possui notificações</div>
            ):''}
          </div>
        </NavDropdown>
      </Nav>
    </ul>
  );
};

export default AlertNotification;
